/**
 * @name staffFrame
 * @description Staff frame filtering and grid management with AJAX
 */
// WordPress's jQuery (enqueued as a dependency) — bundling our own shipped a second copy.
const $ = window.jQuery;

module.exports = function() {
  var $staffForm = $('.staff-frame form');
  var $staffGrid = $('.staff-frame .staff-grid');

  if (!$staffForm.length || !$staffGrid.length) return;

  // Store current data for resize recalculation
  var currentStaffData = {
    staffCards: [],
    logoCards: [],
    staffCount: 0
  };
  var isFiltered = false;

  // Load cards on page load
  filterStaff(false);

  // Get cards per row based on window width (matching SCSS breakpoints)
  function getCardsPerRow() {
    var width = $(window).width();
    if (width >= 1700) return 6;      // xxxl
    if (width >= 1440) return 5;      // xxl
    if (width >= 992) return 4;       // lg
    if (width >= 768) return 3;       // md
    return 2;                          // default
  }

  // Calculate how many logos needed
  // On init: minimum 6 rows worth of cards
  // On filter: just fill the current last row
  function getLogosNeeded(staffCount, cardsPerRow, isFiltered) {
    if (!isFiltered) {
      // Init: minimum 6 rows
      var minRows = 6;
      var minCards = cardsPerRow * minRows;

      if (staffCount < minCards) {
        return minCards - staffCount;
      }

      var remainder = staffCount % cardsPerRow;
      if (remainder === 0) return cardsPerRow;
      return cardsPerRow - remainder;
    }

    // Filtered: fill the last row
    var remainder = staffCount % cardsPerRow;
    if (remainder === 0) return cardsPerRow;
    return cardsPerRow - remainder;
  }

  // Prevent form submission and use AJAX instead
  $staffForm.on('submit', function(e) {
    e.preventDefault();
    filterStaff();
  });

  // Handle radio button changes
  $staffForm.find('input[type="radio"]').on('change', function() {
    filterStaff(true);
  });

  // Handle search input with debounce
  var searchTimeout;
  $staffForm.find('input[name="s"]').on('input', function() {
    clearTimeout(searchTimeout);
    var hasSearch = ($(this).val() || '').trim() !== '';
    searchTimeout = setTimeout(function() {
      // A search should look across ALL staff, not just the currently selected
      // department — otherwise searching for someone outside the active filter
      // returns zero results (and visitors may not realise a filter is on).
      // Reset the department filter to "everyone" whenever there's a search term.
      if (hasSearch) {
        var $everyone = $staffForm.find('input[name="department-filter"][value="everyone"]');
        if ($everyone.length && !$everyone.prop('checked')) {
          $everyone.prop('checked', true);
        }
      }
      filterStaff(true);
    }, 300);
  });

  // Handle window resize with debounce
  var resizeTimeout;
  $(window).on('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      if (currentStaffData.staffCards.length > 0) {
        renderGrid(false); // Re-render without animation
      }
    }, 150);
  });

  function filterStaff(animate) {
    var department = $staffForm.find('input[name="department-filter"]:checked').val() || 'everyone';
    var search = $staffForm.find('input[name="s"]').val() || '';
    var $section = $staffGrid.closest('section');
    var color = $section.hasClass('light') ? 'white' : 'primary';

    // Determine block mode from section classes
    var blockMode = 'default';
    if ($section.hasClass('light')) blockMode = 'light';
    else if ($section.hasClass('dark')) blockMode = 'dark';
    else if ($section.hasClass('accent')) blockMode = 'accent';

    // Add loading state
    $staffGrid.addClass('loading');

    $.ajax({
      url: ajaxData.ajaxurl,
      type: 'POST',
      data: {
        action: 'filter_staff',
        nonce: ajaxData.nonce,
        department: department,
        search: search,
        color: color,
        block_mode: blockMode
      },
      success: function(response) {
        if (response.success) {
          // Store the data for resize recalculation
          currentStaffData = response.data;

          // Shuffle staff cards order
          shuffleArray(currentStaffData.staffCards);

          if (animate) {
            isFiltered = true;
          }

          renderGrid(animate);
        }
      },
      complete: function() {
        $staffGrid.removeClass('loading');
      }
    });
  }

  // Fisher-Yates shuffle
  function shuffleArray(array) {
    for (var i = array.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var temp = array[i];
      array[i] = array[j];
      array[j] = temp;
    }
    return array;
  }

  function renderGrid(animate) {
    var cardsPerRow = getCardsPerRow();
    var logosNeeded = getLogosNeeded(currentStaffData.staffCount, cardsPerRow, isFiltered);
    var $existingCards = $staffGrid.find('.staff-card');

    if (animate) {
      // Flip out all existing cards at once
      $existingCards.addClass('flip-out');

      // After flip-out animation, update content and flip back in
      setTimeout(function() {
        buildGrid(cardsPerRow, logosNeeded, true);
      }, 400);
    } else {
      // Instant update (for resize)
      buildGrid(cardsPerRow, logosNeeded, false);
    }
  }

  function buildGrid(cardsPerRow, logosNeeded, animate) {
    $staffGrid.empty();

    // Start with staff cards
    var allCards = [];
    currentStaffData.staffCards.forEach(function(card) {
      allCards.push(card.html);
    });

    // Reserve 1 logo for the last position, randomly distribute the rest (never first)
    var logoCards = currentStaffData.logoCards || [];
    var logosToDistribute = logosNeeded - 1;
    for (var i = 0; i < logosToDistribute; i++) {
      var logoIndex = i % logoCards.length;
      var randomIndex = Math.floor(Math.random() * allCards.length) + 1;
      allCards.splice(randomIndex, 0, logoCards[logoIndex] || '');
    }

    // Last card is always a logo (branded version)
    allCards.push(currentStaffData.logoHtmlLast);

    // Render all cards
    allCards.forEach(function(cardHtml) {
      var $newCard = $(cardHtml);

      if (animate) {
        $newCard.addClass('flip-in');
      }

      $staffGrid.append($newCard);
    });

    // Trigger flip-in animation
    if (animate) {
      setTimeout(function() {
        $staffGrid.find('.staff-card').removeClass('flip-in').addClass('flip-in-active');
      }, 50);

      // Clean up classes after animation
      setTimeout(function() {
        $staffGrid.find('.staff-card').removeClass('flip-in-active');
      }, 500);
    }
  }
};
